import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import Loader from 'react-loader';

import ListBody from './ListBody';
import ListHeader from './ListHeader';

import './styles/List.css';

const List = ({ data, headers, loading, className }) => (
  <Loader
    lines={13}
    loaded={!loading}
    loadedClassName="sectioned-items sectioned-items--loaded"
    parentClassName="sectioned-items sectioned-items--loading"
    position="relative"
    width={2}
  >
    <Table className={`tvt-report-list ${className}`} striped hover>
      <ListHeader headers={headers} />
      <ListBody data={data} fields={headers} />
    </Table>
  </Loader>
);

List.defaultProps = {
  loading: false,
  data: []
};

List.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.any),
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired,
  className: PropTypes.string
};

List.defaultProps = {
  className: ''
};

export default List;
